import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Authentication, Environments } from '../../core/sap-cp.enum';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { select, Store } from '@ngrx/store';
import {
  destinationsSelector,
  EnviromentSelector,
  SapConfigurationSelector,
  SapConfigurationsSelector
} from '../store/selectors/sap-selectors';
import {
  GetAllDestinations,
  GetAllDestinationsSuccess,
  GetSAPConfigurationsSuccess, GetSAPConfigurationSuccess,
  UpdateSAPConfiguration,
  UpdateSAPConfigurationSuccess
} from '../store/actions/sap-actions';
import { BzgModalService, BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { EnvironmentType } from '../../../core/models/environment-type';
import { AuthCodeGrantService } from 'app/connect/auth-code-grant/auth-code-grant.service';
import { AuthenticationFlow, commons, IgnoreProperToRequestCode, Oauth2Properties } from 'app/connect/auth-code-grant/core/enums';
import { AuthCodeGrantComponent } from 'app/connect/auth-code-grant/auth-code-grant.component';
import { CredentialTokenOauth } from 'app/connect/auth-code-grant/core/CredentialTokenOauth';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { ConectConfirmModalComponent } from 'app/connect/conect-confirm-modal/conect-confirm-modal.component';
import { IAppState } from 'app/IAppState';
const DEFAULT_VERSION = '2';

@Component({
  selector: 'biz-sap-config-detail',
  templateUrl: './sap-config-detail.component.html',
  styleUrls: ['./sap-config-detail.component.scss']
})

export class SapConfigDetailComponent implements OnInit, OnChanges {

  @ViewChild('authcodegrant', { static: false}) authcodegrant: AuthCodeGrantComponent;
  @Input() sapConfiguration: ISAPConfiguration;
  @Output() cancelAction: EventEmitter<any> = new EventEmitter<any>()
  private sapId: string;
  authTypes = [
    {
      displayName: 'Basic Authentication',
      value: Authentication.BasicAuthentication
    },
    {
      displayName: 'No Authentication',
      value: Authentication.NoAuthentication
    }
  ];
  configurationForm: FormGroup;
  destinations$: Observable<ISAPDestination[]>;
  destinationSub: any;
  public authenticationFlow = AuthenticationFlow;
  selectedAuthenticationFlow: AuthenticationFlow;

  updateSuccess$: Observable<string>;
  updateSuccessSub: any;
  destinations: ISAPDestination[];
  enviroment = 'Dev';
  // 0: dev, 1:test, 2:prod
  envDestinations: ISAPEnviroments =
    {
      0: {
        destination: '',
        AuthenticationUrl: '',
        ClientId: '',
        ClientSecret: '',
        recordOauth: null,
        authenticationFlowType: AuthenticationFlow.codeGrant, 
        destinationProxyType : ''
      },
      1: {
        destination: '',
        AuthenticationUrl: '',
        ClientId: '',
        ClientSecret: '',
        recordOauth: null,
        authenticationFlowType: AuthenticationFlow.codeGrant,
        destinationProxyType : ''
      },
      2: {
        destination: '',
        AuthenticationUrl: '',
        ClientId: '',
        ClientSecret: '',
        recordOauth: null,
        authenticationFlowType: AuthenticationFlow.codeGrant,
        destinationProxyType : ''
      }
    };

  isLoading: boolean;
  bizagiEnv: string;
  saveSapConfiguration: ISAPConfiguration;
  redirectUrl: string;
  recordOauth: IDataAuthorizationCodeGrant;
  sapConfigurationOrig: ISAPConfiguration;
  modalConfirmationTittle: string;
  modalConfirmationMessage: string;
  version = "Version";
  

  constructor(private translate: TranslateService, private formBuilder: FormBuilder, private store: Store<IAppState>, private toastService: BzgToastService,
    private authCodeGrantService: AuthCodeGrantService, private _cryptoDataService: CryptoDataService, private _modalService: BzgModalService) {
    this.configurationForm = this.formBuilder.group({
      name: ['', Validators.required],
      dispatcherUrl: ['', Validators.required],
      odataVersion: ['', Validators.required],
      redirectUri: ['', Validators.required],
      xsuaaUrl: ['', Validators.compose([Validators.required, Validators.pattern(commons.patterUrl)])],
      xsuaaClientId: ['', Validators.required],
      xsuaaClientSecret: ['', Validators.required],
      destination: ['', Validators.required],
      authenticationType: [0, Validators.required],
      authenticationFlowType: [0, Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sapConfiguration && !changes.sapConfiguration.isFirstChange()) {
      this.initData(changes.sapConfiguration.currentValue);
    }
  }

  async ngOnInit() {
    if (this.sapConfiguration) {
      this.initData(this.sapConfiguration);
    }
    this.translateNames();
    this.makeSubscriptions();
    this.redirectUrl = await this.authCodeGrantService.getServerUrl();
    this.configurationForm.controls['redirectUri'].setValue(this.redirectUrl);
    this.configurationForm.controls['redirectUri'].disable();

    this.translate.get('GLOBAL.CONFIRMATION').subscribe(translation => {
      this.modalConfirmationTittle = translation;
    });
    this.translate.get('SAP_CP_CONFIGURATION.CONFIGURATION.CHANGES_DETECTED').subscribe(translation => {
      this.modalConfirmationMessage = translation;
    });
  }

  private makeSubscriptions() {
    this.destinations$ = this.store.pipe(select(destinationsSelector));
    this.destinationSub = this.destinations$.subscribe((destinationsC => {
      if (destinationsC && destinationsC.length > 0) {
        this.configurationForm.controls['name'].disable();
        this.destinations = destinationsC;
          this.translate.get(['SAP_CP_CONFIGURATION.CONFIGURATION.DESTINATIONS_OK']).pipe(take(1)).subscribe(translate => {
            this.toastService.open(translate['SAP_CP_CONFIGURATION.CONFIGURATION.DESTINATIONS_OK'], {
              type: 'success',
              horizontalPosition: 'right',
              verticalPosition: 'top',
              verticalMargin: 20,
              duration: 5000
            });
          })        
          this.configurationForm.controls['destination'].setValue(this.getDestination(this.configurationForm.controls['destination'].value, destinationsC));                    
      }
      this.isLoading = false;
    }));
    this.updateSuccess$ = this.store.pipe(select(SapConfigurationSelector));
    this.updateSuccessSub = this.updateSuccess$.subscribe(value => {
      if (value == "true") {
        this.translate.get(['SAP_CP_CONFIGURATION.CONFIGURATION.SUCCESS_UPDATE']).pipe(take(1)).subscribe(translate => {
          this.toastService.open(translate['SAP_CP_CONFIGURATION.CONFIGURATION.SUCCESS_UPDATE'], {
            type: 'success',
            horizontalPosition: 'right',
            verticalPosition: 'top',
            verticalMargin: 20,
            duration: 5000
          });
          this.isLoading = false;
        })
        this.store.dispatch(new UpdateSAPConfigurationSuccess(""));
        this.store.pipe(select(SapConfigurationsSelector)).pipe(take(1)).subscribe(configs => {
          var configsCopy = JSON.parse(JSON.stringify(configs));
          let envDests =
          {
            0: {
              Destination: this.saveSapConfiguration.environments[0].destination,
              AuthenticationUrl: this.saveSapConfiguration.environments[0].AuthenticationUrl,
              ClientId: this.saveSapConfiguration.environments[0].ClientId,
              ClientSecret: this.saveSapConfiguration.environments[0].ClientSecret,
              recordOauth: this.saveSapConfiguration.environments[0].recordOauth,
              authenticationFlowType: this.saveSapConfiguration.environments[0].authenticationFlowType,
              destinationProxyType: this.saveSapConfiguration.environments[0].destinationProxyType,
            },
            1: {
              Destination: this.saveSapConfiguration.environments[1].destination,
              AuthenticationUrl: this.saveSapConfiguration.environments[1].AuthenticationUrl,
              ClientId: this.saveSapConfiguration.environments[1].ClientId,
              ClientSecret: this.saveSapConfiguration.environments[1].ClientSecret,
              recordOauth: this.saveSapConfiguration.environments[1].recordOauth,
              authenticationFlowType: this.saveSapConfiguration.environments[1].authenticationFlowType,
              destinationProxyType: this.saveSapConfiguration.environments[1].destinationProxyType,
            },
            2: {
              Destination: this.saveSapConfiguration.environments[2].destination,
              AuthenticationUrl: this.saveSapConfiguration.environments[2].AuthenticationUrl,
              ClientId: this.saveSapConfiguration.environments[2].ClientId,
              ClientSecret: this.saveSapConfiguration.environments[2].ClientSecret,
              recordOauth: this.saveSapConfiguration.environments[2].recordOauth,
              authenticationFlowType: this.saveSapConfiguration.environments[2].authenticationFlowType,
              destinationProxyType: this.saveSapConfiguration.environments[2].destinationProxyType,
            }
          };
          let i = configsCopy.findIndex(config => config.id === this.sapConfiguration.id);
          configsCopy[i] = JSON.parse(JSON.stringify(this.saveSapConfiguration));
          configsCopy[i].environments = envDests;
          this.store.dispatch(new GetSAPConfigurationsSuccess(configsCopy));
        })
      }else if((value == "false")){
        this.translate.get(['SAP_CP_CONFIGURATION.CONFIGURATION.ERROR_UPDATE']).pipe(take(1)).subscribe(translate => {
          this.toastService.open(translate['SAP_CP_CONFIGURATION.CONFIGURATION.ERROR_UPDATE'], {
            type: 'error',
            horizontalPosition: 'right',
            verticalPosition: 'top',
            verticalMargin: 20,
            duration: 5000
          });
        })
        this.isLoading = false;
        this.store.dispatch(new UpdateSAPConfigurationSuccess(""));
      }
    })
    this.isLoading = false;
  }

  ngOnDestroy() {
    this.store.dispatch(new GetAllDestinationsSuccess([]));
    if (this.destinationSub) {
      this.destinationSub.unsubscribe()
    }
    if (this.updateSuccessSub) {
      this.updateSuccessSub.unsubscribe()
    }
  }
  private initData(sapConfig) {
    this.isLoading = true;
    this.destinations = null;
    this.configurationForm.controls['name'].setValue(sapConfig.name);
    this.configurationForm.controls['name'].disable();
    this.configurationForm.controls['dispatcherUrl'].setValue(sapConfig.dispatcherUri ? sapConfig.dispatcherUri : sapConfig.dispatcherUrl);
    this.configurationForm.controls['odataVersion'].setValue(sapConfig.odataVersion ? sapConfig.odataVersion : DEFAULT_VERSION);
    this.configurationForm.controls['odataVersion'].disable();
    this.configurationForm.controls['authenticationType'].setValue(sapConfig.authenticationType + 1);
    const env: ISAPEnviroments = {
      0: {
        destination: sapConfig.environments.Development ? sapConfig.environments.Development.Destination : sapConfig.environments[0].Destination,
        AuthenticationUrl: sapConfig.environments.Development ? sapConfig.environments.Development.AuthenticationUrl : sapConfig.environments[0].AuthenticationUrl,
        ClientId: sapConfig.environments.Development ? sapConfig.environments.Development.ClientId : sapConfig.environments[0].ClientId,
        ClientSecret: sapConfig.environments.Development ? sapConfig.environments.Development.ClientSecret : sapConfig.environments[0].ClientSecret,
        recordOauth: sapConfig.environments.Development ? sapConfig.environments.Development.recordOauth : sapConfig.environments[0].recordOauth,
        authenticationFlowType: sapConfig.environments.Development ? sapConfig.environments.Development.authenticationFlowType : sapConfig.environments[0].authenticationFlowType,
        destinationProxyType : sapConfig.environments.Development ? sapConfig.environments.Development.destinationProxyType : sapConfig.environments[0].destinationProxyType,
      },
      1: {
        destination: sapConfig.environments.Test ? sapConfig.environments.Test.Destination : sapConfig.environments[1].Destination,
        AuthenticationUrl: sapConfig.environments.Test ? sapConfig.environments.Test.AuthenticationUrl : sapConfig.environments[1].AuthenticationUrl,
        ClientId: sapConfig.environments.Test ? sapConfig.environments.Test.ClientId : sapConfig.environments[1].ClientId,
        ClientSecret: sapConfig.environments.Test ? sapConfig.environments.Test.ClientSecret : sapConfig.environments[1].ClientSecret,
        recordOauth: sapConfig.environments.Test ? sapConfig.environments.Test.recordOauth : sapConfig.environments[1].recordOauth,
        authenticationFlowType: sapConfig.environments.Test ? sapConfig.environments.Test.authenticationFlowType : sapConfig.environments[1].authenticationFlowType,
        destinationProxyType : sapConfig.environments.Development ? sapConfig.environments.Test.destinationProxyType : sapConfig.environments[1].destinationProxyType,
      },
      2: {
        destination: sapConfig.environments.Production ? sapConfig.environments.Production.Destination : sapConfig.environments[2].Destination,
        AuthenticationUrl: sapConfig.environments.Production ? sapConfig.environments.Production.AuthenticationUrl : sapConfig.environments[2].AuthenticationUrl,
        ClientId: sapConfig.environments.Production ? sapConfig.environments.Production.ClientId : sapConfig.environments[2].ClientId,
        ClientSecret: sapConfig.environments.Production ? sapConfig.environments.Production.ClientSecret : sapConfig.environments[2].ClientSecret,
        recordOauth: sapConfig.environments.Production ? sapConfig.environments.Production.recordOauth : sapConfig.environments[2].recordOauth,
        authenticationFlowType: sapConfig.environments.Production ? sapConfig.environments.Production.authenticationFlowType : sapConfig.environments[2].authenticationFlowType,
        destinationProxyType : sapConfig.environments.Development ? sapConfig.environments.Production.destinationProxyType : sapConfig.environments[2].destinationProxyType,
      },
    }

    //Update Original Configuration
    this.sapConfigurationOrig = {
      id: this.sapId,
      name: sapConfig.name,
      dispatcherUrl: sapConfig.dispatcherUri ? sapConfig.dispatcherUri : sapConfig.dispatcherUrl,
      authenticationType: sapConfig.authenticationType + 1,
      environments: JSON.parse(JSON.stringify(env))
    };

    this.envDestinations = env;
    this.store.pipe(select(EnviromentSelector)).pipe(take(1)).subscribe(env => {
      if(!this.destinations && this.envDestinations[EnvironmentType[env]].destination){
        this.destinations = [{ Name: this.envDestinations[EnvironmentType[env]].destination, ProxyType:this.envDestinations[EnvironmentType[env]].destinationProxyType }]
      }
      this.bizagiEnv = env;
      this.configurationForm.controls['xsuaaUrl'].setValue(this.envDestinations[EnvironmentType[env]].AuthenticationUrl);
      this.configurationForm.controls['xsuaaClientId'].setValue(this.envDestinations[EnvironmentType[env]].ClientId);
      this.configurationForm.controls['xsuaaClientSecret'].setValue(this.envDestinations[EnvironmentType[env]].ClientSecret);
      let destinationObject:ISAPDestination = {
        Name: this.envDestinations[EnvironmentType[env]].destination,
        ProxyType: this.envDestinations[EnvironmentType[env]].destinationProxyType
      } 
      this.configurationForm.controls['destination'].setValue(this.getDestination(destinationObject, this.destinations));      
      this.configurationForm.controls['authenticationFlowType'].setValue(this.envDestinations[EnvironmentType[env]].authenticationFlowType);
      this.selectedAuthenticationFlow = this.envDestinations[EnvironmentType[env]].authenticationFlowType;      
      this.enviroment = Environments[EnvironmentType[env]];
      this.recordOauth = this.envDestinations[EnvironmentType[env]].recordOauth;
    })
    this.sapId = sapConfig.id;
    this.isLoading = false;

  }

  onEnvChange(event) {
    this.enviroment = event;
    this.configurationForm.controls['destination'].setValue(this.envDestinations[Environments[event.toLowerCase()]].destination);
  }

  getDestination(destinationObj: ISAPDestination, listDestinations: ISAPDestination[]) {
    let destination = null;
    if(listDestinations)
      destination = listDestinations.find(d =>
        d.Name == destinationObj.Name && ((destinationObj.ProxyType && destinationObj.ProxyType != "") ?  d.ProxyType == destinationObj.ProxyType : true));        
    destination = destination ? destination : { name: destinationObj.Name, proxyType: destinationObj.ProxyType};
    return destination;     
  }

  private translateNames() {
    this.translate.get(['SAP_CP_CONFIGURATION.CONFIGURATION.BASIC_AUTHENTICATION', 
                        'SAP_CP_CONFIGURATION.CONFIGURATION.NO_AUTHENTICATION',
                        'SAP_CP_CONFIGURATION.CONFIGURATION.VERSION',
                      ]).subscribe(translations => {
      this.authTypes[0].displayName = translations['SAP_CP_CONFIGURATION.CONFIGURATION.BASIC_AUTHENTICATION'];
      this.authTypes[1].displayName = translations['SAP_CP_CONFIGURATION.CONFIGURATION.NO_AUTHENTICATION'];

      this.version = translations['SAP_CP_CONFIGURATION.CONFIGURATION.VERSION'];
    });
  }

  setAuthType(event) {
    this.envDestinations[Environments[this.enviroment.toLowerCase()]].authenticationFlowType = event.value;
    this.selectedAuthenticationFlow = event.value;
    this.recordOauth = null;
  }

  setXsuaaUrl(event) {
    this.envDestinations[Environments[this.enviroment.toLowerCase()]].AuthenticationUrl = event.target.value;
    this.recordOauth = null;
  }

  setXsuaaClientId(event) {
    this.envDestinations[Environments[this.enviroment.toLowerCase()]].ClientId = event.target.value;
    this.recordOauth = null;
  }

  setXsuaaClientSecret(event) {
    this.envDestinations[Environments[this.enviroment.toLowerCase()]].ClientSecret = event.target.value;
    this.recordOauth = null;
  }

  setDestination(event : ISAPDestination) {
    this.envDestinations[Environments[this.enviroment.toLowerCase()]].destination = event?.Name;
    this.envDestinations[Environments[this.enviroment.toLowerCase()]].destinationProxyType = event?.ProxyType;
    this.sapConfigurationOrig.environments[Environments[this.enviroment.toLowerCase()]].destination = event?.Name;
    this.sapConfigurationOrig.environments[Environments[this.enviroment.toLowerCase()]].destinationProxyType = event?.ProxyType;
  }

  unSelectAction() {
    this.ngOnDestroy();
    this.cancelAction.emit();
  }

  hasChangedAfterAuth(sapConfigOrig: ISAPConfiguration, sapConfigNew: ISAPConfiguration) {
    let changed = false;
    if (sapConfigOrig.dispatcherUrl != sapConfigNew.dispatcherUrl) {
      changed = true;
    }
    else if (JSON.stringify(sapConfigOrig.environments) != JSON.stringify(sapConfigNew.environments)) {
      changed = true;
    }
    return changed;
  }

  isValidToSave() {
    let valid = true;
    let sapConfigurationNew: ISAPConfiguration = {
      id: this.sapId,
      name: this.configurationForm.controls['name'].value,
      dispatcherUrl: this.configurationForm.controls['dispatcherUrl'].value,
      authenticationType: this.configurationForm.controls['authenticationType'].value - 1,
      environments: JSON.parse(JSON.stringify(this.envDestinations))
    };
    return valid && !this.hasChangedAfterAuth(this.sapConfigurationOrig, sapConfigurationNew);
  }

  saveConfiguration() {
    if (this.configurationForm.status != "VALID") {
      this.toastService.open('There are required inputs unfilled or incorrectly formatted', {
        type: 'error',
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 0
      });
      return;
    }

    var SaveConfiguration = () => {
      let sapConfiguration: ISAPConfiguration = {
        id: this.sapId,
        name: this.configurationForm.controls['name'].value,
        dispatcherUrl: this.configurationForm.controls['dispatcherUrl'].value,
        authenticationType: this.configurationForm.controls['authenticationType'].value - 1,
        odataVersion: this.configurationForm.controls['odataVersion'].value,
        environments: this.envDestinations
      };
      if (this.sapId) {
        this.isLoading = true;
        this.saveSapConfiguration = sapConfiguration;
        this.store.dispatch(new UpdateSAPConfiguration(sapConfiguration, this.sapId));
      };
    }
    this.isValidToSave() ? SaveConfiguration() : this.showConfirmDialog(SaveConfiguration);
  }

  getDestinations() {
    if (this.recordOauth && this.isValidToken(this.recordOauth)) {
      if (this.configurationForm.controls['dispatcherUrl'].invalid) {
        this.toastService.open('There are required inputs unfilled', {
          type: 'error',
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 0
        });
        return;
      }
      if (this.configurationForm.controls['dispatcherUrl'].valid) {
        this.isLoading = true;
        this.store.dispatch(new GetAllDestinations(this.configurationForm.controls['dispatcherUrl'].value, this.recordOauth.accessToken));
      }
    }
  }

  getActions() {
    if (this.sapConfiguration.actionList) {
      return Object.keys(this.sapConfiguration.actionList).map((key) => this.sapConfiguration.actionList[key]);
    }
    return null;
  }

  disableBotonByNoAuth() {
    return (this.recordOauth && this.isValidToken(this.recordOauth)) ? false : true;
  }

  onOauthData(value: CredentialTokenOauth, addToSave: boolean = true) {
    this.recordOauth = {
      expiresIn: value.expiresIn,
      accessToken: value.token,
      refreshToken: value.refreshToken,
      accessTokenCreationDateUtc: value.creationDate,
      environmentType: Environments[this.enviroment]
    }

    if (addToSave) {
      this.envDestinations[Environments[this.enviroment]].recordOauth = this.recordOauth;
    }

    ///Update Original configuration
    this.sapConfigurationOrig = {
      id: this.sapId,
      name: this.sapConfigurationOrig.name,
      dispatcherUrl: this.sapConfigurationOrig.dispatcherUrl,
      authenticationType: this.sapConfigurationOrig.authenticationType,
      environments: JSON.parse(JSON.stringify(this.envDestinations))
    };
  }

  resetDestinations(){
    this.destinations = [];
    this.setDestination(null);
  }

  async authorize() {
    if (!this.validateInputs()) {
      return;
    }
    this.resetDestinations();
    if (this.selectedAuthenticationFlow == AuthenticationFlow.codeGrant) {
      var oauthProperties = [{ name: "response_type", value: "code" },
      { name: "redirect_uri", value: this.configurationForm.controls['redirectUri'].value },
      { name: "client_id", value: this.configurationForm.controls['xsuaaClientId'].value },
      { name: "auth_url", value: this.configurationForm.controls['xsuaaUrl'].value + "/oauth/authorize" },
      { name: "token_url", value: this.configurationForm.controls['xsuaaUrl'].value + "/oauth/token" },
      { name: "client_secret", value: this.configurationForm.controls['xsuaaClientSecret'].value }
      ]
      this.decrypProperties(oauthProperties, ["client_id", "client_secret"], this._cryptoDataService, () => {
        let oath2CodeGrantURL = this.buildPetition(oauthProperties);
        let propertiesList = oauthProperties.map(function (m) {
          return { "key": m.name, "value": m.value };
        });
        this.authcodegrant.openWindow(oath2CodeGrantURL, propertiesList);
      });
    } else {
      let properties = this.buildClientCredentialsProperties();
      if (properties) {
        var credentialTokenOauth = await this.authCodeGrantService.getTokeClientCredentials(properties);
        if (credentialTokenOauth) {
          this.translate.get('GLOBAL.TOKEN_CODE_GRANT_WAS_SUCCESSFULLY').subscribe((message: string) => {
            this.toastService.open(
              message,
              {
                type: 'success',
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'right'
              });
            this.onOauthData(credentialTokenOauth, false);
          });
        }
      }
    }
  }

  buildClientCredentialsProperties() {
    var oauthProperties = [{ name: "grant_type", value: "client_credentials" },
    { name: "client_id", value: this.configurationForm.controls['xsuaaClientId'].value },
    { name: "token_url", value: this.configurationForm.controls['xsuaaUrl'].value + "/oauth/token" },
    { name: "client_secret", value: this.configurationForm.controls['xsuaaClientSecret'].value }]
    return oauthProperties.map(function (m) {
      return { "key": m.name, "value": m.value };
    });
  }

  async decrypProperties(properties: any[], nameProperties: string[], _cryptoDataService, callback) {
    for (let i = 0; i < properties.length; i++) {
      let prop = properties[i];
      if (nameProperties.some(name => name == prop.name)) {
        prop.value = await this._cryptoDataService.decryptString(prop.value);
      }
    }
    callback();
  }

  validIgnoreProperties(name: string) {
    var ignoreProper = [];
    for (var key in IgnoreProperToRequestCode) {
      ignoreProper.push(IgnoreProperToRequestCode[key]);
    }
    return !ignoreProper.some(p => p == name);
  }

  buildPetition(propertiesNew) {
    let url = propertiesNew.find(pro => pro.name == Oauth2Properties.auth_url).value;
    //Add properties
    let urlParam = propertiesNew.filter(pro => this.validIgnoreProperties(pro.name))
      .map(m => {
        let name = m.name;
        let value = m.value;
        if (m.name == Oauth2Properties.redirect_uri) {
          value = encodeURIComponent(m.value);
        }
        return name + "=" + value
      }).reduce(function (a, b) { return (a + "&" + b) });
    //adding state to redirect back after getting the code
    let state = commons.state + "=" + this.redirectUrl;
    return url + "?" + urlParam + "&" + state;
  }

  validateInputs() {
    var ok = false;
    if (this.hasErroresExcept(this.configurationForm, ["destination"])) {
      this.toastService.open('There are required inputs unfilled', {
        type: 'error',
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 0
      });
    } else {
      ok = true;
    }
    return ok;
  }

  hasErroresExcept(formgroup: FormGroup, listException: string[]) {
    var hasFail = false;
    for (let field in this.configurationForm.controls) {
      if (!listException.some(excep => excep == field)) {
        const control = this.configurationForm.get(field);
        if (control.status == "INVALID") {
          hasFail = true;
          continue;
        }
      }
    }
    return hasFail;
  }

  copyToclipboard(value) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.translate.get('GLOBAL.TEXT_COPIED').subscribe((message: string) => {
      this.toastService.open(
        message,
        {
          type: 'info',
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    });
  }

  isValidToken(token: IDataAuthorizationCodeGrant): boolean {
    let ok = false;
    if (token.accessTokenCreationDateUtc) {
      let dateCreation = Date.parse(token.accessTokenCreationDateUtc.toString())
      let dateExpires = dateCreation + (token.expiresIn * 1000);
      let dateActually = Date.parse(new Date().toUTCString());
      ok = dateActually <= dateExpires
    }
    return ok;
  }

  public showConfirmDialog(callback) {
    const confirmModal = this._modalService.open(ConectConfirmModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: this.modalConfirmationTittle,
        message: this.modalConfirmationMessage,
        button: "OK"
      }
    });
    confirmModal.afterClosed().subscribe((result: string) => {
      if (result === 'ok') {
        callback();
      }
    })
  }
}
